import Swiper from 'swiper';
import {FreeMode, Navigation} from 'swiper/modules';
import {
    DETAIL_PREFIX,
    applyImageOrientation,
    getOrientationClasses,
    updateImageOrientationFromImage,
} from '../catalog-image-orientation';

const mainPhoto = document.querySelector('.catalog-detail__image');
const mainLink = document.querySelector('.catalog-detail__image-wrapper');
const thumbSwiper = document.querySelector('.catalog-detail__swiper-thumbs');

if (mainPhoto && mainLink) {
    updateImageOrientationFromImage(mainLink, mainPhoto, DETAIL_PREFIX);
}

if (thumbSwiper && mainPhoto && mainLink) {
    new Swiper(thumbSwiper, {
        modules: [FreeMode, Navigation],
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        navigation: {
            prevEl: '.catalog-detail__thumb-prev',
            nextEl: '.catalog-detail__thumb-next',
        },
        on: {
            click(swiper) {
                const slide = swiper.clickedSlide;

                if (!slide) {
                    return;
                }

                const big = slide.dataset.big;
                const width = Number(slide.dataset.width);
                const height = Number(slide.dataset.height);

                mainPhoto.src = big;
                mainLink.href = big;

                swiper.slides.forEach((s) => s.classList.remove('swiper-slide-active'));
                slide.classList.add('swiper-slide-active');

                mainLink.classList.remove(...getOrientationClasses(DETAIL_PREFIX));

                if (width && height) {
                    applyImageOrientation(mainLink, width, height, DETAIL_PREFIX);
                } else {
                    updateImageOrientationFromImage(mainLink, mainPhoto, DETAIL_PREFIX);
                }
            },
        },
    });
}
